module.exports = __webpack_public_path__ + "img/active3.5bd13d55.png";